var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image",attrs:{"src":_vm.statusInterSectingImg,"alt":_vm.statusInterSectingAlt}})}
var staticRenderFns = []

export { render, staticRenderFns }